/**
 * Clamp the long .desc text inside a Vitec archive hero (e.g. /lagenheter/{city}/,
 * plugins/vitec-marknad-cm's archive-rental-objects.php) to 4 lines on mobile,
 * with a fade-out + "Läs mer" button that reveals the full text on click.
 *
 * Mobile only — desktop is left completely untouched. Only applied when the
 * text actually overflows 4 lines; short descriptions are left as-is.
 */

const MOBILE_BREAKPOINT = 767;
const CLAMP_CLASS = 'template__hero-desc--clamped';

function clampHeroDescriptions() {
	if (window.innerWidth > MOBILE_BREAKPOINT) {
		return;
	}

	document.querySelectorAll('.template__hero .desc').forEach(function (desc) {
		if (desc.dataset.readmoreInit) {
			return;
		}
		desc.dataset.readmoreInit = '1';

		desc.classList.add(CLAMP_CLASS);

		const isOverflowing = desc.scrollHeight > desc.clientHeight + 1;

		if (!isOverflowing) {
			desc.classList.remove(CLAMP_CLASS);
			return;
		}

		const readMoreBtn = document.createElement('button');
		readMoreBtn.type = 'button';
		readMoreBtn.className = 'template__hero-desc__read-more';
		readMoreBtn.innerHTML = 'Läs mer<span><img src="' + wpurl.site + '/assets/src/images/arrow-right-white.png" alt="arrow icon"></span>';

		readMoreBtn.addEventListener('click', function () {
			desc.classList.remove(CLAMP_CLASS);
			readMoreBtn.remove();
		});

		desc.insertAdjacentElement('afterend', readMoreBtn);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', clampHeroDescriptions);
} else {
	clampHeroDescriptions();
}
